import { useEffect, useState } from "react";
import { Card, Drawer, Skeleton, message } from "antd";

import { useAuth } from "../../../../../../store/AuthContext/AuthContext";
import { authRequest } from "../../../../../../common/request/authRequest";
import { Place } from "../../../../../components/model/business/FieldsGroup";
import { GeogridAndListPanel } from "../../_common/GeogridAndListPanel";
import { KeywordResultKeyword } from "../../_common/GridComponents";
import { GeogridHistoryBar } from "../../_common/GeogridHistoryBar";

export const GeogridPlaceDrawer = (props: { place: any, keyword: string, onFinish: any }) => {                    
    
    const [data, setData] = useState<any>(null);    
    const [history, setHistory] = useState<any>(null);    
    const [filterGridId, setFilterGridId] = useState<any>('');    
    const { projectGroup } = useAuth();
    const [currentGrid, setCurrentGrid] = useState<number>();

    const { logOut } = useAuth();    

    useEffect(() => {
        setHistory(null);            
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/historic/places/${props.place.cid}?keyword=${props.keyword}`,
            { method: 'GET' }
            )
            .then((data) => {      
                setHistory(data);   
                setCurrentGrid(data.length - 1);                                                 
            })
            .catch((error) => {
                setHistory([]);
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        
                    }
                }
            });            
        }, []); 

    useEffect(() => {
        
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/places/${props.place.cid}?keyword=${props.keyword}${filterGridId}`,
            { method: 'GET' }
            )
            .then((data) => {                
                setData(data);                                              
            })
            .catch((error) => {
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        message.error('Token expirado')
                        logOut();
                    }
                }
            });            
        }, [filterGridId]); 

    return (
        <>
        <Drawer
            placement="right"
            width={'90%'}
            open={true}
            onClose={props.onFinish}
            bodyStyle={{ background: '#F4F7FA', padding:'0px 10px' }}            
            headerStyle={{ background: '#F4F7FA' }}
            title={<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>                
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>                
                    <KeywordResultKeyword keyword={props.keyword} inverted />
                </div>
                <div style={{fontSize:'14px'}}>
                    <Place place={props.place}/>
                </div>
            </div>}>               
                {history === null ? (
                    <div style={{ margin: '2px 10px 0', padding: '6px 12px' }}>
                        <Skeleton active title={false} paragraph={{ rows: 1, width: '55%' }} />
                    </div>
                ) : history.length > 0 ? (
                    <GeogridHistoryBar
                        history={history}
                        currentGrid={currentGrid ?? history.length - 1}
                        onSelect={(grid, index) => {
                            setFilterGridId('&id=' + grid.id);
                            setCurrentGrid(index);
                        }}
                    />
                ) : null}
            <Card style={{position:'relative',margin:'0px 10px', boxSizing:'border-box', height:'97%', backgroundColor:'transparent', borderRadius:10}}>              
                {data && <GeogridAndListPanel geogrid={data.geoGrid}/> }
            </Card>            
        </Drawer>            									                
        </>
    );
};
